import { gql } from '@apollo/client'

export const SETTLEMENT_TYPES_QUERY = gql`
  query settlementTypes($sortBy: SettlementTypeSort, $filter: SettlementTypeFilter) {
    settlementTypes(sortBy: $sortBy, filter: $filter) {
      collection {
        id
        title
      }
    }
  }
`
